import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../../../common/constants";
import { deleteOrganizationUrl } from "../../../../../config";
import api from "../../../../../api";

const DELETE_ORGANIZATION: string = "deleteOrganization";

interface IDeleteOrganization {
  status: string;
  msg: string | null;
  error: string | null;
}

const initialState: IDeleteOrganization = {
  status: Status.IDLE,
  msg: null,
  error: null,
};

export const deleteOrganization: any = createAsyncThunk(
    DELETE_ORGANIZATION,
  async ({ orgId }: { orgId }) => {
    try {
      const url = `${deleteOrganizationUrl}?orgId=${orgId}`;
      const response = await api.delete(url);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "Delete Organization failed";
    }
  }
);

const deleteOrganizationSlice = createSlice({
  name: "deleteOrganization",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteOrganization.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
        state.error = null;
      })
      .addCase(deleteOrganization.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message || "Organization deleted successfully";
      })
      .addCase(deleteOrganization.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
        state.msg = action.error.message || "Failed to delete Organization";
      });
  },
});

type Selector = {
    deleteOrganizationApi: ReturnType<typeof deleteOrganizationSlice.reducer>;
};

export const selector = (store: Selector) => store["deleteOrganizationApi"];

export default deleteOrganizationSlice.reducer;
